var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2351 19.4117C12.7675 19.41 12.3201 19.2229 11.991 18.8911L9.34399 16.2441C8.65487 15.555 8.65487 14.4361 9.34399 13.7471C10.0331 13.058 11.152 13.058 11.841 13.7471L13.3322 15.2382L18.2645 11.0117C19.0737 10.4682 20.1704 10.6844 20.7131 11.4935C21.1639 12.1659 21.1004 13.0579 20.5587 13.6588L14.3822 18.9529C14.0672 19.2388 13.6605 19.402 13.2351 19.4117Z",
    fill: "#3AB402"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C6.71561 30 0 23.2844 0 15C0 6.71561 6.71561 0 15 0C23.2844 0 30 6.71561 30 15C30 23.2844 23.2844 30 15 30ZM15 3.52939C8.66473 3.52939 3.52939 8.66473 3.52939 15C3.52939 21.3353 8.66473 26.4706 15 26.4706C21.3353 26.4706 26.4706 21.3353 26.4706 15C26.4706 8.66473 21.3353 3.52939 15 3.52939Z",
    fill: "#3AB402"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.42fb797505893c625c7386cd6cc5c5a0.svg";
export { ForwardRef as ReactComponent };